import OutboundRequestLogRepository from "../repository/outbound-request-log-repository";

class OutboundRequestLogService
{
    #outboundRequestLogRepository;

    constructor() {
        this.#outboundRequestLogRepository = new OutboundRequestLogRepository();
    }

    async findOne(id) {
        try {
            const data = await this.#outboundRequestLogRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            const data = await this.#outboundRequestLogRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default OutboundRequestLogService;